<template>
  <el-descriptions>
    <slot name="content"></slot>
    <el-descriptions-item label="类型：" v-if="account.corporate">{{corporateList.find(kk => kk.id === account.corporate)?.name}}</el-descriptions-item>
    <!-- 对公转账 -->

    <template v-if="account.corporate === 1">
      <el-descriptions-item label="公司全称：">{{account.name}}</el-descriptions-item>
      <el-descriptions-item label="银行账号：">{{account.no}}</el-descriptions-item>
      <el-descriptions-item label="开户行：">{{account.bank}}</el-descriptions-item>
      <el-descriptions-item label="行号：">{{account.bankNo}}</el-descriptions-item>
    </template>
      <!-- 对私转账 -->
    <template v-if="!account.corporate || account.corporate === 2">
      <el-descriptions-item label="支付类型：" >{{payTypeList.find(kk => kk.id === account.type)?.name}}</el-descriptions-item>
      <!--  支付宝\银行卡-->
      <template v-if="[2, 3].includes(account.type)">
        <el-descriptions-item label="账号：">{{account.no}}</el-descriptions-item>
        <el-descriptions-item label="账户名：">{{account.name}}</el-descriptions-item>
      </template>
      <!-- 银行卡 -->
      <el-descriptions-item label="开户行：" v-if="[3].includes(account.type)">{{account.bank}}---</el-descriptions-item>
    </template>
  </el-descriptions>
</template>
<script>
import { defineComponent, reactive, toRefs, watch } from 'vue'
import { corporateList, payTypeList } from '@/utils/index'

export default defineComponent({
  name: 'AccountPreview',
  props: {
    account: { type: Object, required: true, default: () => null }
  },
  setup(props) {
    console.log(props.account, 'account')
    const dataMap = reactive({
      corporateList,
      payTypeList
      // account: props.account
    })

    watch(() => props.account, () => {
      // da
      console.log(props.account, 'props.account')
    })
    return { ...toRefs(dataMap) }
  }

})
</script>
